import React from "react";
export const BackIcon = () => <i className="fas fa-reply me-2"></i>;
